import initialState from './initialState';
import { types } from '../actions/terytActions';

export default function tertytReducer(state = initialState.teryt, action) {
  switch (action.type) {
    case types.GET_STREETS:
    case types.GET_LOCALITIES: {
      return { fetching: true, streets: state.streets, localities: state.localities };
    }
    case types.GET_STREETS_FAILURE:
    case types.GET_LOCALITIES_FAILURE: {
      return { fetching: false, streets: state.streets, localities: state.localities };
    }
    case types.GET_LOCALITIES_SUCCESS: {
      const { data } = action;
      return { 
        fetching: false, 
        localities: data,
        streets: state.streets,
      };
    }
    case types.GET_STREETS_SUCCESS: {
      const { data } = action;
      return { 
        fetching: false, 
        streets: data,
        localities: state.localities,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/terytReducer.js